
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vanliga-fragor",
      function () {
        return require("private-next-pages/vanliga-fragor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vanliga-fragor"])
      });
    }
  